import styled from 'styled-components'

export const Container = styled.div`
  p {
    color: ${props => props.theme.colors.grey.tone700};
  }

  a {
    color: ${props => props.theme.colors.blue.tone400};
    font-weight: 600;
  }

  margin-bottom: 32px;
`
